import React from "react";
import { Helmet } from "react-helmet";
import MarketTable from "../components/MarketTable";
import OsmosisData from "../components/OsmosisData";
import LibraLiquidity from "../components/LibraLiquidity";
import ArticleList from "../components/ArticleList";

const Home = ({ priceVolumeData, stats, osmosisPoolData, buyOrders }) => {
  return (
    <>
      <Helmet>
        <title>Order Book - Libra World from 0L Network</title>
        <meta
          name="description"
          content="Explore data and analytics for the Libra token from the 0L Network based on public OTC 0Lswap data."
        />
        <link rel="canonical" href="https://libra-world.vercel.app/" />
      </Helmet>
      <div className="container mx-auto my-8 text-gray-600 flex flex-col justify-center items-center text-center ">
        <h1 className="text-3xl font-bold text-gray-800 mb-4">Libra World</h1>
        <h2 className="text-xl max-w-lg mx-auto mb-8">
          Explore Libra token data and analytics on the 0L Network.
        </h2>

        <MarketTable
          olswapData={priceVolumeData}
          olswapStats={stats}
          osmosisPoolData={osmosisPoolData}
        />
        <LibraLiquidity
          osmosisPoolData={osmosisPoolData}
          buyOrders={buyOrders}
        />
        <OsmosisData osmosisPoolData={osmosisPoolData} />

        <ArticleList />

        <section className="mb-20">
          <h3 className="text-2xl font-semibold mb-4">
            0L Network Official Links
          </h3>
          <p className="mb-4">
            Explore the essential links to all official 0L Network resources
          </p>
          <ul className="mb-8">
            <li className="pb-2">
              <a
                href="https://0l.network/"
                className="text-blue-600 hover:text-blue-800"
                target="_blank"
                rel="noopener noreferrer"
              >
                Website
              </a>
            </li>
            <li className="pb-2">
              <a
                href="https://github.com/0LNetworkCommunity"
                className="text-blue-600 hover:text-blue-800"
                target="_blank"
                rel="noopener noreferrer"
              >
                GitHub
              </a>
            </li>
            <li className="pb-2">
              <a
                href="https://discord.gg/Ry2cf4NrbS"
                className="text-blue-600 hover:text-blue-800"
                target="_blank"
                rel="noopener noreferrer"
              >
                Discord
              </a>
            </li>
            <li className="pb-2">
              <a
                href="https://twitter.com/0LNetwork"
                className="text-blue-600 hover:text-blue-800"
                target="_blank"
                rel="noopener noreferrer"
              >
                Twitter
              </a>
            </li>
          </ul>
        </section>
      </div>
    </>
  );
};

export default Home;
